/* unplugin-vue-components disabled */import { render } from "./glpMedicine.vue?vue&type=template&id=01ba0938&scoped=true"
import script from "./glpMedicine.vue?vue&type=script&lang=js"
export * from "./glpMedicine.vue?vue&type=script&lang=js"

import "./glpMedicine.vue?vue&type=style&index=0&id=01ba0938&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ba0938"]])

export default __exports__